import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-center flex-column p-9" }
const _hoisted_2 = {
  key: 0,
  class: "symbol symbol-65px symbol-circle mb-5"
}
const _hoisted_3 = {
  key: 1,
  class: "symbol symbol-65px symbol-circle mb-5"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-success position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-white h-15px w-15px ms-n3 mt-n3"
}
const _hoisted_5 = {
  href: "javascript:void(0)",
  class: "fs-4 text-gray-800 text-hover-primary fw-bolder mb-0",
  style: {"text-transform":"capitalize"}
}
const _hoisted_6 = {
  style: {"text-transform":"capitalize"},
  class: "fw-bold text-gray-400 mb-6"
}
const _hoisted_7 = { class: "d-flex flex-center flex-wrap mb-5 flex-column" }
const _hoisted_8 = { class: "min-w-125px py-3 px-4 mx-3 mb-3" }
const _hoisted_9 = {
  style: {"text-align":"center"},
  class: "fs-6 fw-bolder text-gray-700"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "min-w-125px py-3 px-4 mx-3 mb-3" }
const _hoisted_12 = {
  style: {"text-align":"center"},
  class: "fs-6 fw-bolder text-gray-700"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" View Profile ")
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 0,
  href: "javacript:void(0)",
  class: "btn btn-sm btn-light-primary"
}
const _hoisted_16 = { class: "svg-icon svg-icon-3" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Connected ")
const _hoisted_18 = { class: "svg-icon svg-icon-3" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Connect ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.cardClasses])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.avatar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                style: _normalizeStyle(`
              background-image: url('${_ctx.profilePicture ?? _ctx.avatar}');
              background-size: cover;`)
              }, null, 4)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass([`text-${_ctx.color} bg-light-${_ctx.color}`, "symbol-label fs-2x fw-bold"])
              }, _toDisplayString(_ctx.initials), 3),
              (_ctx.online)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.jobTitle), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                target: "_blank",
                href: _ctx.linkedInProfile
              }, "LinkedIn", 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.introduction), 1)
          ])
        ]),
        _createVNode(_component_router_link, {
          to: `/founder/${_ctx.founderId}`,
          class: "btn btn-sm btn-light-primary my-2",
          style: {"padding-right":"31px","padding-left":"31px"}
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["to"]),
        (!_ctx.fromConnectedExperts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.isConnected)
                ? (_openBlock(), _createElementBlock("a", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                    ]),
                    _hoisted_17
                  ]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.attachExpert && _ctx.attachExpert(...args))),
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-light"
                  }, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                    ]),
                    _hoisted_19
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}